module.exports = __webpack_public_path__ + "static/media/doc.d234d0a6.png";